import { useMediaQuery } from "react-responsive";

// This is only for use with the login page
export const useIsXLScreenLogin = () => {
  return useMediaQuery({ minWidth: "1240px", minHeight: "790px" });
};
